export const modalCloseAction = {
  createSite: 'createSite',
  createWithSpecialist: 'createWithSpecialist',
  close: 'close',
  understand: 'understand',
};

export const steps = {
  finishStep: '99',
};
